/**
 *
 * Asynchronously loads the component for PlayGroundPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const PlayGroundPage = lazyLoad(
  () => import('./index'),
  module => module.PlayGroundPage,
);
